<template>
  <div class="home">
    <headers class="wow fadeInDown"></headers>
    <div class="homemain">
      <div class="homemainl">
<!--        <div ref="elementLeft"  class="item1 transition wow fadeInLeft">
          <item>
            <item1 title="安徽省合肥市/绿地中心"></item1>
          </item>
        </div>-->
        <div class="item2 transition wow fadeInLeft"
             data-wow-delay="0.5s">
          <item>
            <item2 title="异常统计"></item2>
          </item>
        </div>
        <div  class="item3 transition wow fadeInLeft" data-wow-delay="1s">
          <item>
            <item3 title="能耗占比"></item3>
          </item>
        </div>
      </div>
      <div class="homemainr">

        <item10></item10>
        <div class="homemainrBottom">
          <div  class="item5 wow fadeInRight transition"
               data-wow-delay="1s">
            <item>
              <item8 title="能耗统计"></item8>
            </item>
          </div>

          <div ref="elementBottom"
               class="item4 wow fadeInUp transition"
               data-wow-delay="1s">
            <item>
              <item5 title="隐患统计"></item5>
            </item>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/headers";
import item from '@/components/singleitem/item'
import item1 from '@/components/singlehome/item1'
import item2 from '@/components/home/item2'
import item3 from '@/components/home/item3'
import item4 from '@/components/singlehome/item4'
import item5 from '@/components/home/item5'
import item6 from '@/components/singlehome/item6'
import item7 from '@/components/singlehome/item6'
import item8 from '@/components/singlehome/item8'
import item9 from '@/components/singlehome/item9'
import item10 from '@/components/singlehome/item10'
export default {
  data() {
    return {
      list: [],
      hide1: false,
      hide2: false,
      hide3: false,
      hide4: false,
      hide5: false,
      hide7: false,
      pointerEvents: 'initial',
      active: false,
      cqyjShow: false
    }
  },
  components: {headers, item, item1, item2, item3, item4, item5, item6, item7, item8, item9, item10},
  created() {

  },
  mounted() {
    new this.$wow.WOW().init()
    this.hide7 = true;
  },
  computed: {
    bottom1: function () {
      var bottom = 0
      if (this.hide4) {
        bottom = this.$refs.elementBottom.offsetHeight*2
      } else {
        bottom = 0
      }
      return bottom
    }
  },
  methods: {

  },
  filters: {

  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  position: fixed;
  height: 100%;
  background: url("../assets/home/bg.png") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: nowrap;
  flex-direction: column;
}

.homemain {
  position: relative;
  width: calc(100% - 0px);
  height: calc(100% - 110px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: nowrap;
  flex-direction: row;
  z-index: 10;
  pointer-events: none;

  .homemainl {
    width: calc(25% - 20px - 23px);
    margin-left: 20px;
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;
    margin-left: 20px;
    margin-right: 23px;
    pointer-events: initial;

    .item1 {
      width: 100%;
      height: calc(38% - 20px);
      margin-bottom: 20px;
      position: relative;
    }

    .item2 {
      width: 100%;
      height: calc(50% - 20px);
      margin-bottom: 20px;
      position: relative;
      margin-top: 20px;
    }

    .item3 {
      width: 100%;
      height: calc(50% - 20px);
      position: relative;
    }
  }

  .homemainr {
    width: calc(75% - 20px);
    position: relative;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: column;
    align-content: flex-start;
    z-index: 11;
    margin-right: 20px;
    .homemainrTop {
      width: 100%;
      height: 30%;
    /*  pointer-events: initial;*/
      display: flex;
      justify-content: space-between;
      flex-direction: row-reverse;
    }

    .homemainrBottom {
      width: 100%;
      height: calc(46% - 20px);
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      flex-direction: row;
      align-content: flex-start;
      pointer-events: initial;

      .item4 {
        width: calc(40% - 20px);
       /* margin-right: 20px;*/
        height: 100%;
      }

      .item5 {
        width: 60%;
        height: 100%;
      }
    }
  }
}

//.footEc {
//  width: 100%;
//  height: 180px;
//  background: #03265a;
//  border: 1px solid #24539e;
//  border-radius: 20px;
//  position: absolute;
//  bottom: 0;
//  z-index: 12;
//}
.leftHide {
  margin-left: -200%;
}

.DownHide {
  margin-bottom: -70%;
}
</style>
